<template>
  <div class="bg">
    <div class="button">
      <div>
        <el-button type="info" size="small" @click="quit">退出</el-button>
      </div>
      <div>
        <router-link :to="{ path: '/temporaryPerson/addPerson' }">
          <!-- <i class="iconfont icon-add" /> -->
          <el-button size="small" type="primary">添加</el-button>
        </router-link>
        <el-button size="small" type="primary" @click="showSearch = true">搜索</el-button>
        <!-- <i @click="showSearch = true" class="iconfont icon-chaxun"></i> -->
      </div>
      <van-popup v-model="showSearch" round position="bottom" :style="{ height: 'auto' }">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          cancel-button-text=" "
          title="请选择认证开始时间"
          confirm-button-text="先确认"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="StartTime"
        />
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="请选择认证结束时间"
          confirm-button-text="先确认"
          cancel-button-text=" "
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="EndTime"
        />
        <div style="text-align: center; margin-top: 10px">
          开始时间：{{ startTime }}，结束时间：{{ endTime }}
        </div>
        <div class="searchBtn">
          <i style="font-size: 10px">（查询前先选择开始时间和结束时间）</i>
          <el-button type="primary" size="mini" @click="itemList"> 查询记录 </el-button>
        </div>
      </van-popup>
    </div>
    <div v-show="showPagination !== 0">
      <div class="content">
        <el-card v-for="(item, index) in listInfo" :key="index">
          <el-row>
            <el-col :span="10">
              <div class="img">
                <van-image
                  height="150"
                  @click="showImage(item.url)"
                  :src="item.url"
                  fit="cover"
                />
              </div>
            </el-col>
            <el-col :span="14">
              <p>
                <span>工人姓名：{{ item.name }}</span>
              </p>

              <p>
                <span>日工资：{{ item.dailyWage }}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"> 所属项目：{{ project }} </el-col>
            <el-col :span="24"> 所属单位：{{ item.unitId }} </el-col>
            <el-col :span="24"> 所属班组：{{ item.teamId }} </el-col>
            <el-col :span="24"> 记录时间：{{ item.createTime }} </el-col>
          </el-row>
        </el-card>
        <el-card v-show="showPagination == 0" body-style="text-align:center">
          <span>暂无数据</span>
        </el-card>
      </div>
      <el-pagination
        :current-page.sync="page.currentPage"
        :page-sizes="page.pageSizes"
        :page-size="page.pageSize"
        :total="page.totalCount"
        layout="sizes ,pager, next "
        :on-load="itemList"
        @size-change="sizeChange"
        @current-change="currentChange"
      />
    </div>
    <el-card v-show="showPagination == 0" body-style="text-align:center">
      <span>暂无数据</span>
    </el-card>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
import { resetRouter } from "@/router/index";
import { clearStore } from "@/utils/storage";
import { postListUnit } from "@/api/app/unit";
import { postTeamDetail } from "@/api/app/team";
import { getProjectList, postProjectId } from "@/api/app/project";
import { postListPage, postMonth } from "@/api/app/temporaryPerson";
export default {
  data() {
    return {
      project: "",
      showSearch: false,
      listInfo: {},
      // 分页
      page: {
        pageSize: 10,
        currentPage: 1,
        totalCount: 0,
        pageSizes: [10, 20, 30, 40, 50, 100],
      },
      query: {},
      showPagination: Number,
      name: "",
      idCardNumber: "",
      minDate: new Date(new Date().getFullYear() - 1, 1, 1),
      maxDate: new Date(new Date().getFullYear() + 3, 1, 1),
      currentDate: new Date(),
      startTime: "开始时间",
      endTime: "结束时间",
    };
  },
  mounted() {
    this.itemList();
  },
  methods: {
    // 列表
    itemList(time, page, params = {}) {
      if (this.startTime !== "开始时间") {
        this.query.startTime = this.startTime;
      }
      if (this.endTime !== "结束时间") {
        this.query.endTime = this.endTime;
      }
      getProjectList().then((res) => {
        let projectId = res.data[0].id;
        this.query.projectId = projectId;
        postListPage(
          this.page.currentPage,
          this.page.pageSize,
          Object.assign(params, this.query)
        ).then((listPage) => {
          listPage.data.result.forEach((item) => {
            if (item.name == undefined) {
              item.name = "未填写";
            }
          });
          this.page = listPage.data;
          this.showPagination = listPage.data.result.length;
          this.showSearch = false;
          // 根据vuex的寸的projectId获取所属项目名称
          postProjectId(projectId).then((res) => {
            this.project = res.data.name;
          });
          // 所属单位
          postListUnit(projectId).then((unit) => {
            listPage.data.result.forEach((id) => {
              unit.data.find((item) => {
                if (id.unitId == item.id) {
                  id["unitId"] = item.title;
                }
              });
            });
            // 所属班组
            listPage.data.result.forEach((id) => {
              postTeamDetail(id.teamId).then((item) => {
                if (id.teamId == item.data.id) {
                  id["teamId"] = item.data.name;
                }
              });
            });
            this.listInfo = listPage.data.result;
          });
        });
      });
    },
    // 开始时间选择
    StartTime(value) {
      this.startTime = this.datePick.datePick(value).substring(0, 10);
    },
    EndTime(value) {
      this.endTime = this.datePick.datePick(value).substring(0, 10);
    },
    // 退出
    quit(params = {}) {
      this.$dialog
        .confirm({
          title: "退出登录",
          message: "确定退出登录",
        })
        .then(() => {
          clearStore(params);
          if (this.$store.state.app.item !== undefined) {
            this.$store.commit("Item", "");
          }
          this.$store.commit("ProjectId", "");
          this.$store.dispatch("logout");
          // 清空动态创建的路由
          //   resetRouter();
          this.$router.push("/temporaryLogin");
        })
        .catch(() => {});
    },
    // 图片预览
    showImage(index) {
      ImagePreview({
        images: [index],
      });
    },
    // 分页
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.itemList(this.page);
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.itemList(this.page);
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  padding: 10px;
  min-height: 100vh;
  background-color: #f0f0f0;
}
.button {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  i {
    font-size: 24px;
    color: #606266;
  }
  .van-field:nth-child(1) {
    margin-top: 45px;
  }
  .van-popup {
    padding: 30px 0 20px 0;
  }
  .searchBtn {
    text-align: right;
    margin-top: 20px;
  }
}
.content {
  font-size: 14px;
  margin-bottom: 10px;
  /deep/ .el-checkbox {
    width: 100%;
  }
  /deep/ .el-checkbox__label {
    width: 100%;
  }
  .el-card {
    margin-bottom: 10px;
  }
  .el-col {
    margin-bottom: 5px;
  }

  // 图片
  .img {
    img {
      width: 130px;
      height: 130px;
      border-radius: 4px;
    }
  }
  P {
    margin: 0 0 5px 5px;
  }
}
// 分页
/deep/ .el-pagination {
  padding: 0;
  overflow: hidden;
}
/deep/ .el-pagination .el-select .el-input {
  margin: 0;
}
</style>
